import React, { useState, useEffect } from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DatePicker = ({ label, description, selectedDate, onChange }) => {
  const [date, setDate] = useState(selectedDate);

  const handleDateChange = (newDate) => {
    setDate(newDate);
    onChange(newDate);
  };

  useEffect(() => {
    if(selectedDate !== date)
      setDate(selectedDate)
  }, [selectedDate])

  return (
    <div className="flex flex-col space-y-2">
      {label && <label className="text-gray-700 font-medium">{label}</label>}
      <ReactDatePicker
        selected={date}
        onChange={handleDateChange}
        className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
        dateFormat="MM/dd/yyyy"
        placeholderText="Select a date"
        popperPlacement="bottom-start"  // Control where the calendar appears
        popperModifiers={{
          preventOverflow: {
            enabled: true,
            boundariesElement: 'viewport',  // Prevent it from being cut off
          },
          offset: {
            enabled: true,
            offset: '0, 10',  // Offset the popper for better positioning
          },
        }}
      />
      {description && <p className="text-sm text-gray-500">{description}</p>}
    </div>
  );
};

export default DatePicker;
